// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Set from "bs-platform/lib/es6/set.js";
import * as List from "bs-platform/lib/es6/list.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Fill$YourProjectName from "./fill/fill.bs.js";

var NamePool = $$Set.Make({
      compare: $$String.compare
    });

function splitList(pred, l) {
  var _left = /* [] */0;
  var _right = l;
  while(true) {
    var right = _right;
    var left = _left;
    if (!right) {
      return [
              List.rev(left),
              /* [] */0
            ];
    }
    var rest = right.tl;
    var h = right.hd;
    if (Curry._1(pred, h)) {
      return [
              List.rev(left),
              rest
            ];
    }
    _right = rest;
    _left = {
      hd: h,
      tl: left
    };
    continue ;
  };
}

function findCoordinate(cs, name) {
  var f = function (c) {
    return c.coordinate_id === name;
  };
  if (List.exists(f, cs)) {
    return List.find(f, cs);
  }
  
}

function findEdge(es, name) {
  var f = function (e) {
    return e.edge_id === name;
  };
  if (List.exists(f, es)) {
    return List.find(f, es);
  }
  
}

function findEdges(es, edgeNames) {
  var f = function (param, l$prime) {
    if (l$prime === undefined) {
      return ;
    }
    var e = findEdge(es, param[0]);
    if (e !== undefined) {
      return {
              hd: Fill$YourProjectName.rotateEdge(param[1], e),
              tl: l$prime
            };
    }
    
  };
  return List.fold_right(f, edgeNames, /* [] */0);
}

function addCoordinate(setState, name, x, y) {
  return Curry._1(setState, (function (s) {
                var cs = s.coordinates;
                var np = s.namePool;
                var match = Curry._2(NamePool.find_opt, name, np);
                var nameExists = match !== undefined;
                if (name === "") {
                  return s;
                }
                var elm = {
                  coordinate_id: name,
                  x: x,
                  y: y
                };
                if (nameExists) {
                  var p = function (c) {
                    return c.coordinate_id === name;
                  };
                  var match$1 = splitList(p, cs);
                  return {
                          mode: s.mode,
                          scale: s.scale,
                          svgx: s.svgx,
                          svgy: s.svgy,
                          namePool: s.namePool,
                          coordinates: Pervasives.$at(match$1[0], Pervasives.$at({
                                    hd: elm,
                                    tl: /* [] */0
                                  }, match$1[1])),
                          edges: s.edges,
                          fills: s.fills
                        };
                }
                var newnp = Curry._2(NamePool.add, name, np);
                return {
                        mode: s.mode,
                        scale: s.scale,
                        svgx: s.svgx,
                        svgy: s.svgy,
                        namePool: newnp,
                        coordinates: {
                          hd: elm,
                          tl: cs
                        },
                        edges: s.edges,
                        fills: s.fills
                      };
              }));
}

function addEdge(setState, name, draw, sname, tname, curve) {
  return Curry._1(setState, (function (s) {
                var np = s.namePool;
                var es = s.edges;
                var cs = s.coordinates;
                var match = findCoordinate(cs, sname);
                var match$1 = findCoordinate(cs, tname);
                if (match === undefined) {
                  return s;
                }
                if (match$1 === undefined) {
                  return s;
                }
                var match$2 = Curry._2(NamePool.find_opt, name, np);
                var nameExists = match$2 !== undefined;
                if (name === "") {
                  return s;
                }
                var elm = {
                  edge_id: name,
                  scoord: sname,
                  tcoord: tname,
                  curve: curve,
                  draw: draw
                };
                if (nameExists) {
                  var p = function (e) {
                    return e.edge_id === name;
                  };
                  var match$3 = splitList(p, es);
                  return {
                          mode: s.mode,
                          scale: s.scale,
                          svgx: s.svgx,
                          svgy: s.svgy,
                          namePool: s.namePool,
                          coordinates: s.coordinates,
                          edges: Pervasives.$at(match$3[0], Pervasives.$at({
                                    hd: elm,
                                    tl: /* [] */0
                                  }, match$3[1])),
                          fills: s.fills
                        };
                }
                var newnp = Curry._2(NamePool.add, name, np);
                return {
                        mode: s.mode,
                        scale: s.scale,
                        svgx: s.svgx,
                        svgy: s.svgy,
                        namePool: newnp,
                        coordinates: s.coordinates,
                        edges: {
                          hd: elm,
                          tl: es
                        },
                        fills: s.fills
                      };
              }));
}

function addFill(setState, name, color, enames) {
  return Curry._1(setState, (function (s) {
                var np = s.namePool;
                var es = s.edges;
                var fs = s.fills;
                var _edges = findEdges(es, enames);
                if (_edges === undefined) {
                  return s;
                }
                var match = Curry._2(NamePool.find_opt, name, np);
                var nameExists = match !== undefined;
                if (name === "") {
                  return s;
                }
                var elm = {
                  fill_id: name,
                  color: color,
                  edges: enames
                };
                if (nameExists) {
                  var p = function (e) {
                    return e.fill_id === name;
                  };
                  var match$1 = splitList(p, fs);
                  return {
                          mode: s.mode,
                          scale: s.scale,
                          svgx: s.svgx,
                          svgy: s.svgy,
                          namePool: s.namePool,
                          coordinates: s.coordinates,
                          edges: s.edges,
                          fills: Pervasives.$at(match$1[0], Pervasives.$at({
                                    hd: elm,
                                    tl: /* [] */0
                                  }, match$1[1]))
                        };
                }
                var newnp = Curry._2(NamePool.add, name, np);
                return {
                        mode: s.mode,
                        scale: s.scale,
                        svgx: s.svgx,
                        svgy: s.svgy,
                        namePool: newnp,
                        coordinates: s.coordinates,
                        edges: s.edges,
                        fills: {
                          hd: elm,
                          tl: fs
                        }
                      };
              }));
}

function usedCoordinate(name, state) {
  var a = function (b, edge) {
    if (b || edge.scoord === name) {
      return true;
    } else {
      return edge.tcoord === name;
    }
  };
  return List.fold_left(a, false, state.edges);
}

function usedEdge(name, state) {
  var a = function (b, fill) {
    if (b) {
      return true;
    }
    var a$prime = function (b$prime, param) {
      var edge = findEdge(state.edges, param[0]);
      if (edge !== undefined) {
        if (b$prime) {
          return true;
        } else {
          return edge.edge_id === name;
        }
      } else {
        return false;
      }
    };
    return List.fold_left(a$prime, false, fill.edges);
  };
  return List.fold_left(a, false, state.fills);
}

function remove(setState, name) {
  return Curry._1(setState, (function (s) {
                if (usedCoordinate(name, s) || usedEdge(name, s)) {
                  return s;
                }
                var match = splitList((function (c) {
                        return c.coordinate_id === name;
                      }), s.coordinates);
                var match$1 = splitList((function (c) {
                        return c.edge_id === name;
                      }), s.edges);
                var match$2 = splitList((function (c) {
                        return c.fill_id === name;
                      }), s.fills);
                return {
                        mode: s.mode,
                        scale: s.scale,
                        svgx: s.svgx,
                        svgy: s.svgy,
                        namePool: s.namePool,
                        coordinates: Pervasives.$at(match[0], match[1]),
                        edges: Pervasives.$at(match$1[0], match$1[1]),
                        fills: Pervasives.$at(match$2[0], match$2[1])
                      };
              }));
}

export {
  NamePool ,
  splitList ,
  findCoordinate ,
  findEdge ,
  findEdges ,
  addCoordinate ,
  addEdge ,
  addFill ,
  usedCoordinate ,
  usedEdge ,
  remove ,
  
}
/* NamePool Not a pure module */
